import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BreadcrumbComponent } from '../../../../core/layout/components/breadcrumb/breadcrumb.component';
import { UserStoreService } from '../../../../shared/services/user-store.service';
import { OrganizationStoreService } from '../../../../shared/services/organization-store.service';
import { ApiUserService } from '../../../../shared/services/api-user.service';

@Component({
  selector: 'app-profile',
  imports: [BreadcrumbComponent, FormsModule],
  templateUrl: './profile.component.html',
})
export class ProfileComponent {
  editing = signal(false);
  saving = signal(false);
  saveError = signal<string | null>(null);

  firstName = '';
  lastName = '';
  cellPhone = '';
  country = '';

  constructor(
    public userStore: UserStoreService,
    public organizationStore: OrganizationStoreService,
    private apiUserService: ApiUserService) {}

  get organizationName(): string {
    const activeOrg = this.userStore.activeOrg();
    return this.organizationStore.organizations().find(o => o.id === activeOrg)?.name ?? activeOrg ?? '—';
  }

  get initials(): string {
    const initials = (this.userStore.firstName().charAt(0) + this.userStore.lastName().charAt(0)).toUpperCase();
    return initials || '?';
  }

  get canSave(): boolean {
    return this.firstName.trim().length > 0 && this.lastName.trim().length > 0;
  }

  startEdit(): void {
    this.firstName = this.userStore.firstName();
    this.lastName = this.userStore.lastName();
    this.cellPhone = this.userStore.cellPhone();
    this.country = this.userStore.country();
    this.saveError.set(null);
    this.editing.set(true);
  }

  cancelEdit(): void {
    if (this.saving()) return;
    this.editing.set(false);
    this.saveError.set(null);
  }

  save(): void {
    if (!this.canSave || this.saving()) return;

    this.saving.set(true);
    this.saveError.set(null);
    this.apiUserService.updateUser({
      firstName: this.firstName.trim(),
      lastName: this.lastName.trim(),
      cellPhone: this.cellPhone.trim(),
      country: this.country.trim()
    }).subscribe({
      next: (response) => {
        this.userStore.setProfile(response);
        this.saving.set(false);
        this.editing.set(false);
      },
      error: (err) => {
        this.saving.set(false);
        this.saveError.set(err?.error?.message ?? err?.message ?? 'Failed to save profile.');
      }
    });
  }
}
